import { atom } from "jotai";

// User State Atoms
export const subscriptionTierAtom = atom(0);
export const subscriptionEndAtom = atom(null);
export const isDemoAtom = atom(false);
export const emailAtom = atom("");
export const preferencesAtom = atom([]);
export const completedTasksAtom = atom({
  this_week: 0,
  last_30_days: 0,
  lifetime: 0,
});
export const referralCodeAtom = atom("");
export const showIntroFlagAtom = atom(true);
